export default "__VITE_ASSET__A$m_pUXk__"